import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "../../styles/main.css"
import { I18nextProvider } from "react-i18next"
import { Provider } from "react-redux"
import { store } from "../../app"
import SearchLayout from "../../shared/Layouts/SearchLayout"

const mountApp = () => {
  const node = document.getElementById("transfer-price-form-react")
  if (!node || node.dataset.mounted) return

  const i18n = window.i18n
  if (!i18n) {
    window.addEventListener("i18n:ready", mountApp, { once: true })
    return
  }

  node.dataset.mounted = "true"

  const props = JSON.parse(node.getAttribute("data-props") || "{}")

  if (props.locale) {
    i18n.changeLanguage(props.locale)
  }

  const root = createRoot(node)
  root.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <SearchLayout themeName={props?.themeName ?? "default"} isAdmin={props?.isAdmin}>
          <App {...props} />
        </SearchLayout>
      </I18nextProvider>
    </Provider>
  )
}

document.addEventListener("DOMContentLoaded", mountApp)
document.addEventListener("turbolinks:load", mountApp)
